import React, { useEffect, useState } from "react";
import {
  FormDataConsumerRenderParams,
  required,
  email,
  TextInput,
} from "react-admin";
import { useForm } from "react-final-form";
import { useAppData } from "../../../common/hooks/useAppData";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface Props extends FormDataConsumerRenderParams {}

export const DriverEmailInput = ({ formData, ...props }: Props) => {
  const tenantDomain = useAppData((x) => x.tenant?.domainName);
  const [calculatedEmail, setCalculatedEmail] = useState<string>();
  const form = useForm();
  useEffect(() => {
    if (!formData["email"] || formData["email"] === calculatedEmail) {
      if (!formData["name"] || !formData["surname"]) {
        return;
      }

      const emailAddress = `${formData["name"].toLowerCase()}.${formData[
        "surname"
      ].toLowerCase()}@${tenantDomain}`;
      setCalculatedEmail(emailAddress);
      form.change("email", emailAddress);
    }
  }, [formData, calculatedEmail, form, tenantDomain]);

  return (
    <ProtectedElement source="email">
      <TextInput
        source="email"
        label="resources.common.labels.email"
        validate={[required(), email()]}
        {...props}
      />
    </ProtectedElement>
  );
};
